/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SapCountryCodesV0 } from './sapCountryCodesV0';


/**
 * Address information is provided in two ways: as a displayable, formatted address string as well as a series of structured attributes. This object allows addresses to to be updated or entered.
 */
export interface AddressDto { 
    /**
     * The Unique Property Reference Number (UPRN) is a unique identifier assigned to each addressable property in the United Kingdom.
     */
    uprn?: string;
    /**
     * Typically the \'Building name\' or \'Building number\', \'House number and street\'.
     */
    addressLine1: string;
    /**
     * If `addressLine1` is A building name then this will be street name and street number. Otherwise it will probably the Post Town.
     */
    addressLine2?: string;
    /**
     * Subsequent lines of address, such as \'\'\'Postal District\'\' or \'\'Postal Town\'\'.
     */
    addressLine3?: string;
    /**
     * An alphanumeric string included in a postal address to facilitate mail sorting (a.k.a. post code, postcode, or ZIP code).
     */
    postalCode: string;
    countryCode: SapCountryCodesV0;
    /**
     * The Postal Town for the Address.
     */
    postalTown?: string;
}
export namespace AddressDto {
}


